import { AssetService } from "../models/assetservice.model";

export class Asset {
    public id: string;
    public serialNumber: string;
    public imei: string;
    public brand: string;
    public model: string;
    public description: string;
    public assetServices: AssetService[] = [] //TODO: implement assetService object
    public deliveryDate: Date;
    public warrantyStartDate: Date;
    public warrantyEndDate: Date;
    public companyId: string;
    public company: any //TODO: implement company object
    public sourceName: string;
    public sourceId: string;
    public userId: string;
    public requests: any[] = [] //TODO: implement requests object

    constructor() {}
}